import React from "react";

export const themeNames = ["white", "blue", "overlay"];
export const initialContextValue = themeNames[0];

const ThemeContext = React.createContext(initialContextValue);

export default ThemeContext;
